
import { Component,ViewChild, OnInit } from '@angular/core';
import { trigger, state, transition, animate, style } from '@angular/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import {NgbTimepickerConfig} from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/crm/auth.service';
import swal from 'sweetalert2';  
//import pdfFonts from "pdfmake/build/vfs_fonts"; // fonts provided for pdfmake
import { DomSanitizer} from '@angular/platform-browser';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { ViewportScroller } from '@angular/common';
//import { Pipe, PipeTransform } from '@angular/core';

/*@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}
  transform(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}  
class ImageSnippet {
  constructor(public src: string, public file: File) {}
}*/

@Component({
  selector: 'app-seguimiento-cliente',
  templateUrl: './seguimiento-cliente.component.html',
  styleUrls: ['./seguimiento-cliente.component.scss']
})
export class SeguimientoClienteComponent implements OnInit {
  public loading = false;
  public nombre:string="";
  @ViewChild('close_mac',null) close_mac;
  constructor(private viewportScroller: ViewportScroller, public authService: AuthService,public router:Router,  config: NgbTimepickerConfig,public sanitizer:DomSanitizer,private modalService: NgbModal) {
    config.spinners = false;  
    this.proyevto_nombre=localStorage.getItem("actividad_nombre");
    //console.log(localStorage.getItem("actividad_nombre"));
    
   }
 public tab:any;
  fecha_hoy:any;
  cliente:any;
  cliente_:any;
  usuario:any;
  active1:any;
  active2:any;
  active3:any;
  active4:any;
  active5:any;
  active6:any;
  public asesores_:any;
  @ViewChild('close1', {static: true}) close1:any; 
  ngOnInit() {  
    this.nombre=localStorage.getItem("nombre");
    //console.log(this.nombre);  
    try {
      this.cliente=localStorage.getItem("cliente");
    } catch (error) {
      this.cliente=0;
    }
    try {
      this.facturas=localStorage.getItem("facturas");
    } catch (error) {
      this.facturas=0;
    }
    this.get_responsable();
    var cli:any=localStorage.getItem("cliente_");
    this.cliente_=JSON.parse(cli);
    this.preventa.rs=this.cliente_.razonsocial;
    this.preventa.rfc=this.cliente_.rfc;      
    try {
      this.usuario=localStorage.getItem("usuario");  
    } catch (error) {
      this.usuario=0;
    }      
    if(this.facturas==1){
      this._secc(4); 
    }else{
      this._secc(2);
    }    
    this.ls_catalogo_tipo_seguimiento();
    this.ls_seguimiento();
    this.ls_departamento();
    this.ls_programado();
    this.ls_proyectos();
    this.ls_medio();
    this.ls_asesores();
    var dt=new Date();
    this.fecha_hoy=dt.getDay().toString()+"/"+dt.getMonth().toString()+"/"+dt.getFullYear().toString();
    this.ls_preventa(this.cliente_);
  }
  bndmnugral=true;
    oculta_menu(){
      console.log("-");
      if(this.bndmnugral==true){
        this.bndmnugral=false;
      }else{
        this.bndmnugral=true;
      }
      console.log(this.bndmnugral);
    }
  segtar_f={
    id:0,
    id_tarea:0,
    fechai : {year: 0, month: 0, day: 0},
    fechat : {year: 0, month: 0, day: 0},
    descripcion:"",
    avance:0,
    responsable:0
  };
  task(itm){
    let postData={
      id_tarea:itm.id,
      id_cliente:localStorage.getItem("id_cliente")
    }
    //console.log(postData);
    this.bndsegtar=true;
      this.loading=true;    
      this.authService.service("/api/sp_task",postData)
      .then( 
          data => {
            this.loading=false;
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat); 
            
          }); 


    localStorage.setItem("bndtask","1");    
    localStorage.setItem("idtarea",itm.id);    

    //this.router.navigate(["task"]);
  }
  asesores_id;
  valida_segtar(){
    //console.log(this.segtar_f.fechai);
    if( this.segtar_f.fechai==undefined){
      swal.fire('Complete la fecha Inicio', '', 'warning');
      return false;
    }
    if(this.segtar_f.fechat==undefined){
      swal.fire('Complete la fecha Término', '', 'warning');
      return false;
    }
    if(this.segtar_f.descripcion==""){
      swal.fire('Complete la descipción', '', 'warning');
      return false;
    }
    if(this.segtar_f.avance==0){
      swal.fire('Complete el avance', '', 'warning');
      return false;
    }
    return true;
  }
  bndgsegtar:boolean=true;
  edt_segtar(itm){
    this.bndgsegtar=false;
    this.bndsegtar=false;
    this.segtar_f.id=itm.id;
    try {
      this.segtar_f.fechai.year=Number(itm.fecha.toString().substring(0,4));
      this.segtar_f.fechai.month=Number(itm.fecha.toString().substring(5,7));
      this.segtar_f.fechai.day=Number(itm.fecha.toString().substring(8,10));    
    } catch (error) {      
      this.segtar_f.fechai=undefined;
    }
    try {
      this.segtar_f.fechat.year=Number(itm.fechat.toString().substring(0,4));
      this.segtar_f.fechat.month=Number(itm.fechat.toString().substring(5,7));
      this.segtar_f.fechat.day=Number(itm.fechat.toString().substring(8,10));    
    } catch (error) {  
      this.segtar_f.fechat=undefined;    
    }        
    this.segtar_f.avance=itm.avance;
    this.segtar_f.descripcion=itm.descripcion;
  }
  updseg_(){
    if(this.valida_segtar()==false)return;   
    //console.log(this.segtar_f);    
    let postData={
      id:this.segtar_f.id,
      id_tarea:this.segtar_f.id_tarea,
      fechai: this.segtar_f.fechai.year + "-" + this.segtar_f.fechai.month + "-" + this.segtar_f.fechai.day,
      fechat: this.segtar_f.fechat.year + "-" + this.segtar_f.fechat.month + "-" + this.segtar_f.fechat.day,
      descripcion:this.segtar_f.descripcion,
      avance:this.segtar_f.avance,
      id_usuario:this.usuario
    }
    //console.log(postData);
    this.bndsegtar=true;
      this.loading=true;    
      this.authService.service("/api/upd_segtar",postData)
      .then( 
          data => {
            this.loading=false;
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat); 
            let postdata={id:this.segtar_f.id_tarea}
            this.ls_segtar(postdata);
            swal.fire('¡Ok! ', '', 'success');
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              this.loading=false;
              swal.fire('¡API incorrecta..! gda_segtar', '', 'error');
          }); 
  }
  gdaseg_(){ 
    if(this.valida_segtar()==false)return;   
    //console.log(this.segtar_f);    
    let postData={
      id_tarea:this.segtar_f.id_tarea,
      fechai: this.segtar_f.fechai.year + "-" + this.segtar_f.fechai.month + "-" + this.segtar_f.fechai.day,
      fechat: this.segtar_f.fechat.year + "-" + this.segtar_f.fechat.month + "-" + this.segtar_f.fechat.day,
      descripcion:this.segtar_f.descripcion,
      avance:this.segtar_f.avance,
      id_usuario:this.usuario
    }
    //console.log(postData);
    this.bndsegtar=true;
      this.loading=true;    
      this.authService.service("/api/gda_segtar",postData)
      .then( 
          data => {
            this.loading=false;
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat); 
            let postdata={id:this.segtar_f.id_tarea}
            this.ls_segtar(postdata);
            swal.fire('¡Ok! ', '', 'success');
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              this.loading=false;
              swal.fire('¡API incorrecta..! gda_segtar', '', 'error');
          }); 
  }
  hid_sel:String="";
  sel_todel(id){
    var a=this.hid_sel.split(",");
    if(a.length>0){      
      //console.log(a);
      if(a.indexOf(id.toString())==-1){
        if (a[0]==""){
          a[0]=id.toString();
        }else{
          a.push(id.toString());
        }
      }else{               
        var i = a.indexOf(id.toString()); 
        a.splice( i, 1 );
      }
      this.hid_sel=a.toString();
    }else{
      this.hid_sel=id.toString();
    }
  }
  act_=0;

  elim_Act(){
    if(confirm("Desea eliminar los registros?")==false)return;
      let postData={
       id_actividad:this.hid_sel,     
      }
      
      //console.log(postData);
      this.loading=true;
      this.authService.service("/api/eli_actividad_proyecto",postData)
        .then(
          data => {
            this.loading=false;
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat); 
            this.close_mac.nativeElement.click();
            this._secc(4); 
            swal.fire('¡Ok! ', '', 'success');
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              this.loading=false;
              swal.fire('¡API incorrecta..! elim_Act', '', 'error');
        }); 
  }

  segtar:any;
  bndsegtar:boolean=true;
  canseg_(){
    this.bndsegtar=true;
  }
  nvseg_(){
    this.bndgsegtar=true;
    //console.log("ssalida");
    this.segtar_f.avance=0;
    this.segtar_f.descripcion="";
    this.segtar_f.fechai=undefined;
    this.segtar_f.fechat=undefined;
    this.bndsegtar=false;
  }  
  ls_segtar(itm){
    this.segtar_f.id_tarea=itm.id;
    this.bndsegtar=true;
    let postData={
      id_tarea:itm.id,     
     }
     //console.log(postData);
     this.loading=true;
     this.authService.service("/api/get_segtar",postData)
       .then(
         data => {
           this.loading=false;
           var dat = JSON.stringify(data);
           var res = JSON.parse(dat);
           this.segtar=res; 
           //console.log(data);
         },
         error => {
             var de= JSON.stringify(error);
             var di = JSON.parse(de)
             this.loading=false;
             swal.fire('¡API incorrecta..! get_segtar', '', 'error');
       });
  }
  mov_actpry(){
    var a=this.hid_sel;
    
    if(a.length==0){
      swal.fire('¡Selecciona al menos una actividad para mover de proyecto', '', 'warning');
    }else{
      this.act_=a.split(",").length;
      var proyecto_="";            
      if(this.actividad.id_proyecto<=0){
        swal.fire('¡Selecciona un proyecto', '', 'warning');
        return;
      }
      if(confirm("Confirma que desea mover ("+a.split(",").length+") actividades al proyecto "+proyecto_+"!")==false)return;
      let postData={
      id_actividad:this.hid_sel,
      id_proyecto:this.actividad.id_proyecto
      }
      //console.log(postData);
      this.loading=true;
      //console.log(postData);
      this.authService.service("/api/upd_actividad_proyecto",postData)
      .then(
          data => {
            this.loading=false;
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat); 
            this._secc(4); 
            this.modalService.dismissAll();
            swal.fire('¡Ok! ', '', 'success');
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              this.loading=false;
              swal.fire('¡API incorrecta..! cmb_pry', '', 'error');
          }); 

    }
  }
  check_(itm){
    var a=this.actividad.asesores.split(",");    
    if(a.length>0){      
      if(a.indexOf(itm.sufijo)==-1){
        if (a[0]==""){
          a[0]=itm.sufijo;
        }else{
          a.push(itm.sufijo);
        }
      }else{               
        var i = a.indexOf(itm.sufijo); 
        a.splice( i, 1 );
      }
      this.actividad.asesores=a.toString();
    }else{
      a=itm.sufijo;
    }
  }
  vlsD:boolean=false;
  vlsA:boolean=false;
  fn_vl(a){
    switch (a) {
      case 'A':
        this.vlsD=false;
        if(this.vlsA==true)this.vlsA=false;
        else this.vlsA=true;
        break;
      case 'D':
        this.vlsA=false;
        if(this.vlsD==true)this.vlsD=false;
        else this.vlsD=true;
        break;    
      default:
        break;
    } 


  }
  check_d(itm){
    console.log(itm);
    var a=this.actividad.departamento.split(",");    
    if(a.length>0){      
      if(a.indexOf(itm.departamento)==-1){
        if (a[0]==""){
          a[0]=itm.departamento;
        }else{
          a.push(itm.departamento);
        }
      }else{               
        var i = a.indexOf(itm.departamento); 
        a.splice( i, 1 );
      }
      this.actividad.departamento=a.toString();
    }else{
      a=itm.departamento;
    }
  }
  medio_:any;
  departamento:any;
  ls_departamento(){
    let postData:any={
      id_cliente:this.cliente,
    };
    //console.log(postData);
    this.authService.service("/api/get_departamento_role",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);         
            //console.log(data);
            //console.log(data);
            this.departamento=data;             
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta..! asesores', '', 'error');
        }); 
  }
  ls_asesores(){
    let postData:any=[];
    this.authService.service("/api/get_asesores",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);         
            //console.log(data);
            //console.log(data);
            this.asesores_=data;             
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta..! asesores', '', 'error');
        }); 
  }
  ls_medio(){
    let postData:any=[];
    this.authService.service("/api/get_medio",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);         
            //console.log(data);
            //console.log(this.medio_);
            this.medio_=data;             
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta..! medio ', '', 'error');
        }); 
  }
  _secc(t:any){       
    this.active1="";
    this.active2="";
    this.active3="";
    this.active4="";
    this.active5="";
    this.active6="";
    this.tab=t;
    switch (t) {
      case 1:
        this.active1="active";
        break;
      case 2:    
        this.active2="active";    
        this.ls_seguimiento();
        break;
      case 3:
        this.active3="active";
        this.ls_programado();
        break;
      case 4:
        this.active4="active";
        this.ls_proyectos();
        this.ls_orden();
        break;
      case 5:
        this.rpt_act=[];
        var d= new Date();
        //console.log(d.toString().substr(8,2));
        this.actividad.fechaIni.day=1;
        this.actividad.fechaIni.month=Number(d.getMonth()+1);
        this.actividad.fechaIni.year=Number(d.getFullYear());
    
        this.actividad.fechaFin.day=Number(d.toString().substr(8,2));
        this.actividad.fechaFin.month=Number(d.getMonth()+1);
        this.actividad.fechaFin.year=Number(d.getFullYear());
       
        this.active5="active";
        //this.ls_facturas();
        break;
      case 6:
        this.active6="active";
        this.ls_reportes();
        break;
      default:
        break;
    }
  }
  ls_reportes(){
   
  }
  ls_facturas(){
    this.Ver_rpt('h',0);
    this.fn_hp('h');
  }

  ls_preventa(itm:any){

    this.preventa.id=itm.id;
    this.preventa.nombre=itm.nombre;
    this.preventa.paterno=itm.paterno;
    this.preventa.materno=itm.materno;
    
    this.preventa.correo=itm.correo;
    this.preventa.tel1=itm.telefono;
    this.preventa.tel2=itm.telefono2;
    this.preventa.ext1=itm.ext1;
    this.preventa.ext2=itm.ext2;
    this.preventa.pais=itm.pais;
    this.preventa.estado=itm.estado;
    this.preventa.municipio=itm.municipio;
    this.preventa.colonia=itm.colonia;
    this.preventa.calle=itm.calle;
    this.preventa.cp=itm.cp;
    this.preventa.medio=itm.medio;
  }
  tipo_seguimiento:any;
  ls_catalogo_tipo_seguimiento(){
    let postData:any=[];
    //console.log("aqui");
    this.authService.service("/api/get_catalogo_tipo_seguimiento",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);         
            //console.log(data);
            this.tipo_seguimiento=data;             
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta..! catalogo tipo seguimiento', '', 'error');
        }); 
    
  }
 
  valida_seguimiento(){
    if(this.seguimiento.tipo==0 || this.seguimiento.descripcion==null || this.seguimiento.descripcion==undefined){
      swal.fire('¡Completar tipo de seguimiento! ', '', 'warning');
      return false;
    }
    if(this.seguimiento.descripcion=="" || this.seguimiento.descripcion==null || this.seguimiento.descripcion==undefined){
      
      swal.fire('¡Completar descripción! ', '', 'warning');
      return false;
    }
    if(Number(this.seguimiento.programado)==1){
      //console.log(this.seguimiento.fecha);
      if(this.seguimiento.fecha.year==0 || this.seguimiento.fecha.year==null || this.seguimiento.fecha.year==undefined){
        swal.fire('¡Completar fecha! ', '', 'warning');
        return false;
      }
      if(this.seguimiento.hora.hour==0 || this.seguimiento.hora.hour==null || this.seguimiento.hora.hour==undefined){
        swal.fire('¡Completar hora! ', '', 'warning');
        return false;
      }
      if(this.seguimiento.notas==""|| this.seguimiento.notas==null || this.seguimiento.notas==undefined){
        swal.fire('¡Completar notas! 1 ', '', 'warning');
        return false;
      }
    }

    
    return true

  }
  hididseguimiento:any;
  _programado_(itm:any){
    this.hididseguimiento=itm.id_seguimiento;
  }
  _programado_c(){
    var notas_;
    if(this.seguimiento.notas==undefined){
      notas_=""
    }else{
      notas_=this.seguimiento.notas;
    }
    var nombre=localStorage.getItem("nombre");
    let postData={
      id:this.hididseguimiento,
      notas:notas_,
      usuario:nombre,
      estado:'A'
    };
   //console.log(postData);
    this.authService.service("/api/gda_seguimiento_programado",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat); 
          this.ls_programado();
          swal.fire('ok!', '', 'success');
          this.close1.nativeElement.click();
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta..! programado c ', '', 'error');
        }); 
      
  }
  _programado_f(){
    var nombre=localStorage.getItem("nombre");
    let postData={
      id:this.hididseguimiento,
      notas:this.seguimiento.notas,
      usuario:nombre,
      estado:'F'
    };
   //console.log(postData);
    this.authService.service("/api/gda_seguimiento_programado",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);
          this.ls_programado();
          swal.fire('ok! ', '', 'success');
          this.close1.nativeElement.click();
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta..!  programado f', '', 'error');
        }); 
      
  }
  _seguimiento:any;
  _programado:any;
  proyectos:any;
  v_proyectos:any;
  /**  *  */
  upd_oc(){
    let postData={
      id:this.seguimiento.id,
      noorden:this.seguimiento.noorden
    };
    //console.log(postData);
    this.authService.service("/api/upd_oc",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat); 
          //console.log(data);  
          this.ls_seguimiento();
          this.modalService.dismissAll()
          swal.fire('¡Ok ', '', 'success');
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta..! upd_oc ', '', 'error');
        }); 
  }
  usuarios;
  _responsables_;
  ls_usuarios(){
    let postData={};    
    this.loading=true;    
    this.authService.service("/api/get_usuarios",postData)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat); 
        
        this.loading=false;
        this.usuarios=data;
        
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          this.loading=false;
          swal.fire('¡API incorrecta..! ls_usuarios', '', 'error');
    }); 
  } 
  delresp_(itm){
    let postData={
      id:itm.id
    };
    this.loading=true;    
    this.authService.service("/api/del_responsables",postData)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);         
        this.loading=false;
        var postdata={
          id:this.segtar_f.id_tarea
        }
        this.ls_responsables(postdata);
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          this.loading=false;
          swal.fire('¡API incorrecta..! ls_responsables', '', 'error');
    }); 
  } 
  gdaresp_(){
    let postData={
      id_usuario:this.segtar_f.responsable,
      id_tarea:this.segtar_f.id_tarea
    };    
    this.loading=true;    
    this.authService.service("/api/gda_responsables",postData)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);         
        this.loading=false;
        var postdata={
          id:this.segtar_f.id_tarea
        }
        this.ls_responsables(postdata);
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          this.loading=false;
          swal.fire('¡API incorrecta..! ls_responsables', '', 'error');
    }); 
  }
  ls_responsables(itm){
    this.segtar_f.id_tarea=itm.id;
    let postData={id_tarea:itm.id};    
    this.loading=true;    
    this.authService.service("/api/get_responsables",postData)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);         
        this.loading=false;
        this._responsables_=data;
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          this.loading=false;
          swal.fire('¡API incorrecta..! ls_responsables', '', 'error');
    }); 
  }

  _oc(itm){
    this.seguimiento.id=itm.id_seguimiento;
    this.seguimiento.noorden=itm.noorden;
    this.seguimiento.descripcion=itm.descripcion;
  }
  _content(itm){
    this._programado_(itm);   
  }
  _segtar_(itm){
    var size='sm'; 
    this.ls_segtar(itm);       
    this.bndsegtar=true; 
    size='lg';
  }
  __responsables_(itm){
    this.ls_usuarios();
    this.ls_responsables(itm);   
  }
 open(content,itm) {
   //console.log(itm);
   var size='sm';   
    switch (content._declarationTContainer.localNames[0]) {
      
    }
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title',size:size}).result.then((result) => {
    //this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
    //this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
 
}
_proyecto_modal(){
  this.act_=0;
}

getDismissReason(reason: any): string {
 if (reason === ModalDismissReasons.ESC) {
   return 'by pressing ESC';
 } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
   return 'by clicking on a backdrop';
 } else {
   return `with: ${reason}`;
 }

}
/** */

  nvo_pry(){
    this.hididproyecto=0;
    this.proyecto.clave="";
    this.proyecto.nombre="";
    this.proyecto.tipo="";
    this.proyecto.chora=0;
    this.proyecto.hora=0;
    this.proyecto.moneda="";
    this.proyecto.noorden="";
    this.proyecto.ajuste=0; 
    this.proyecto.responsable=0;
    this.v_proyectos=1;
    this.bndeditpry=true;
  }
  ls_proyectos(){
    this.loading=true;
    this.v_proyectos=2;
    let postData={
      id_cliente:this.cliente,
    };
    //console.log(postData);
    this.authService.service("/api/get_proyectos",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat); 
          //console.log(data);  
          this.proyectos=data;
          this.loading=false;
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta..! ', '', 'error');
        }); 

  }
  actividad={
    id_proyecto:0,
    id:0,
    nombre:"",
    fecha : {year: 0, month: 0, day: 0},
    hora : {hour: 0, minute: 0},
    horas:0,
    departamento:"",
    asesores:"",
    medio:0,
    fechaIni : {year: 0, month: 0, day: 0},
    fechaFin : {year: 0, month: 0, day: 0},
    avance:0,
    notas:"",
    eventid:"",
    link:"",
    __fecha:"",
    __hora:""
  }
  bndeditact:boolean=false;
  nva_actpry(){
    this.actividad.id=0
    this.actividad.nombre="";
    this.actividad.fecha.year=2021;
    this.actividad.fecha.month=2021;
    this.actividad.fecha.day=2021;
    this.actividad.hora.minute=0;
    this.actividad.hora.hour=0;
    this.actividad.horas=1;
    this.actividad.departamento="";
    this.actividad.asesores="";
    this.actividad.medio=0;
    this.actividad.avance=100;
    this.actividad.notas="";
    this.actividad.eventid="";
    this.actividad.link="";
    //this.v_proyectos=3;
    this.bndeditact=true;
  }
  can_act(){
    this.close_mac.nativeElement.click();
    this.v_proyectos=4;
  }
  cpry:boolean=false;
  chnpry(t){
    switch (t) {
      case 0:
        this.cpry=false;    
        break;
        case 1:
          this.cpry=true;    
          break;    
      default:
        break;
    }
    
  }
  mes_(m){
    switch(m){
      case 1:return "Ene";break;
      case 2:return "Feb";break;
      case 3:return "Mar";break;
      case 4:return "Abr";break;
      case 5:return "May";break;
      case 6:return "Jun";break;
      case 7:return "Jul";break;
      case 8:return "Ago";break;
      case 9:return "Sep";break;
      case 10:return "Oct";break;
      case 11:return "Nov";break;
      case 12:return "Dic";break;
      default:break;
    }
  }
  dupl_tarea(itm:any){
  
  }
  eli_act(){
    let postData={
      id:this.actividad.id
    }
    this.elimina_tarea(postData);
  }
  elimina_tarea(itm:any){    
    if(confirm("Desea eliminar este registro")==false)return;
    let postData={
      id:itm.id
    }
    this.loading=true;
    this.authService.service("/api/elimina_actividades",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);       
          var id_proyecto_={id:this.hididproyecto};     
          this.tareas_(id_proyecto_);
          this.close_mac.nativeElement.click();
          this.loading=false;
          //var indice = this.actividades.indexOf(itm.id); // obtenemos el indice
          //this.actividades.splice(indice, 1);
          swal.fire('¡Ok¡ ', '', 'success');
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta..! elimina_tarea', '', 'error');
            this.loading=false;
        } 
    );
  }
  bnd_dupl=0;
  dupl_act(){
    this.bnd_dupl=1;
    this.gda_act();
    this.bnd_dupl=0;
  }
  

  _week_=0;
  edita_tarea(itm:any){
    //console.log(itm);
    this._week_=itm.week;
    this.actividad.nombre=itm.actividad;
    let dateString = itm.fecha; 
   
    var f =dateString.toString().substring(8,10);
    //console.log("fecha--"+itm.hora_.toString().substring(3,6));
   //console.log(dateString);
    this.actividad.id=itm.id;
    this.actividad.id_proyecto=itm.id_proyecto;
    this.actividad.__fecha=itm.fecha.substring(0,10)
    this.actividad.__hora=itm.hora_;
    

    
    this.actividad.horas=itm.horas;
    this.actividad.departamento=itm.equipo;
    this.actividad.asesores=itm.interviene;
    this.actividad.medio=itm.medio;
    this.actividad.avance=itm.avance; 
    this.actividad.notas=itm.Notas;
    this.actividad.eventid=itm.id_google;
    this.actividad.notas=itm.link;
    //console.log(this.actividad);
    //this.v_proyectos=3;
    this.bndeditact=false;
  }
  actividad_nombre:String="";
  actividades:any;
  valida_act(){
    if(this.actividad.nombre=="" || this.actividad.nombre==null || this.actividad.nombre==undefined){      
      swal.fire('¡Completar nombre de actividad! ', '', 'warning');
      return false;
    }
  
    if(this.actividad.__fecha==null || this.actividad.hora.hour==undefined){
      swal.fire('¡Completar fecha de reunión! ', '', 'warning');
      return false;
    }
    if(this.actividad.__hora==null || this.actividad.__hora==undefined){
      swal.fire('¡Completar hora! ', '', 'warning');
      return false;
    }
    if(this.actividad.horas==0 || this.actividad.horas==null || this.actividad.horas==undefined){
      swal.fire('¡Completar número horas! ', '', 'warning');
      return false;
    }
    if(this.actividad.departamento=="" || this.actividad.departamento==null || this.actividad.departamento==undefined){
      swal.fire('¡Completar departamento! ', '', 'warning');
      return false;
    }
    if(this.actividad.asesores=="" || this.actividad.asesores==null || this.actividad.asesores==undefined){
      swal.fire('¡Completar asesores! ', '', 'warning');
      return false;
    }
    if(this.actividad.medio==0 || this.actividad.medio==null || this.actividad.medio==undefined){
      swal.fire('¡Completar medio! ', '', 'warning');
      return false;
    }
    /*if(this.actividad.avance==0 || this.actividad.avance==null || this.actividad.avance==undefined){
      swal.fire('¡Completar avance! ', '', 'warning');
      return false;
    }*/ 
    return true;
  }
  cero_fecha(n){
    if(n<=9){
      return "0"+n
    }
    else{
      return n
    }
  }
  async gda_act(){
    if(this.valida_act()==false)return;
    var _fecha=this.actividad.__fecha+" "+ this.actividad.__hora;
    let postData={
      id_proyecto:this.hididproyecto,
      fecha:_fecha,
      actividad:this.actividad.nombre,
      horas:Number(this.actividad.horas),
      departamento:this.actividad.departamento,
      interviene:this.actividad.asesores,
      medio:this.actividad.medio,
      id_usuario:Number(this.usuario),
      avance:this.actividad.avance,
      notas: this.actividad.notas==undefined?"":this.actividad.notas
    };
    //console.log(postData);
  var week_aux=0;  
  await this.authService.service("/api/week",{fec:this.actividad.__fecha+" "+this.actividad.__hora })
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat); 
        week_aux=res[0].week;
      }); 
   this.loading = true;            
    this.authService.service("/api/gda_actividades",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat); 
          //console.log("dupl");
          //console.log(res.insertId);
          this.v_proyectos=4; 
          var id_proyecto_={id:this.hididproyecto};   
          //this.tareas_(id_proyecto_);
          //console.log(this.actividad);
          this.actividades.push(
            {
              id:res.insertId,
              actividad:this.actividad.nombre,
              equipo:this.actividad.departamento,
              interviene:this.actividad.asesores,
              medio:Number(this.actividad.medio),
              avance:Number(this.actividad.avance),
              
              anio:this.actividad.fecha.year,
              mes:this.actividad.fecha.month,
              dia:this.actividad.fecha.day,
              week:week_aux,
              
              Notas:this.actividad.notas,
              horas:this.actividad.horas,                 
              fecha:this.actividad.__fecha+"T"+this.actividad.__hora+":00.000Z",      
              fecha_:this._fec(this.actividad.__fecha),
              hora_ :this.actividad.__hora
            }
          );
          this.calcula_horas_aux();
          //*/
          this.close_mac.nativeElement.click();
          this.loading = false;            
          swal.fire('¡Ok¡ ', '', 'success');
        },
        error => {
            this.loading=false;
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta..! gda_act', '', 'error');
        }); 
  }
  _deloc(itm){
    if(confirm("Confirma que desea eliminar el registro?")==false) return;
    let postData={
      id:itm.id_seguimiento
    }
    //console.log(postData)
    this.authService.service("/api/del_seguimiento",postData)
    .then(
        data => {
          this.ls_seguimiento();

        },
        error => {
            this.loading=false;
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta..! gda_act', '', 'error');
        }); 
  }
  ff(f){
    var n=Number(f);
    //console.log("m="+n);
    if(n<10){
      return "0"+n;
    }else return f
  }
  _fec(f){
    var n=f.split("-");
      return n[2]+"-"+n[1]+"-"+n[0];
  }
  async upd_act(){  
    if(this.valida_act()==false)return;  
    var _fecha=this.actividad.__fecha+" "+ this.actividad.__hora;
    let postData={
      id_actividad:this.actividad.id,
      id_proyecto:this.hididproyecto,
      fecha:_fecha,
      actividad:this.actividad.nombre,
      horas:this.actividad.horas,
      departamento:this.actividad.departamento,
      interviene:this.actividad.asesores,
      medio:this.actividad.medio,
      id_usuario:this.usuario,
      avance:this.actividad.avance,
      notas: this.actividad.notas
    };
    var week_aux=0;  
    await this.authService.service("/api/week",{fec:this.actividad.__fecha+" "+this.actividad.__hora })
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat); 
          week_aux=res[0].week;
        }); 
    this.loading = true;  
    //console.log(postData)     
    this.authService.service("/api/upd_actividades",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);           
          //var id_proyecto_={id:this.hididproyecto};               
          for(var j=0;j<this.actividades.length;j++){
            if(this.actividades[j].id==this.actividad.id){              
              this.actividades[j].actividad=this.actividad.nombre;
              this.actividades[j].equipo=this.actividad.departamento;
              this.actividades[j].interviene=this.actividad.asesores;
              this.actividades[j].medio=Number(this.actividad.medio);
              this.actividades[j].avance=Number(this.actividad.avance);
              this.actividades[j].Notas=this.actividad.notas;
              this.actividades[j].horas=this.actividad.horas;
              this.actividades[j].avance=this.actividad.avance;
              
              this.actividades[j].anio =this.actividad.fecha.year;
              this.actividades[j].mes =this.actividad.fecha.month;
              this.actividades[j].dia =this.actividad.fecha.day;
              this.actividades[j].week =week_aux;
              //"2021-07-28T03:04:00.000Z"
              this.actividades[j].fecha =this.actividad.__fecha+"T"+this.actividad.__hora+":00.000Z";
              this.actividades[j].fecha_ =this._fec(this.actividad.__fecha);
              this.actividades[j].hora_ =this.actividad.__hora;
              //console.log(this.actividades[j]);
              //console.log(this.actividad);
            }
            
          }
          //this.actividades.sort((a,b) => a.fecha.localeCompare(b.fecha)); 
          this.calcula_horas_aux(); 
          this.close_mac.nativeElement.click();
          this.v_proyectos=4;                
          this.loading=false;
           
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta..! upd_act ', '', 'error');
        });
        return;
  }

 
  proyevto_nombre:any;
  async calcula_week(act,j){    
    //console.log("week")
    
      let postData={
        fec:act 
      };
      
      this.authService.service("/api/week",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat); 
            //console.log("week:"+res[0].week)
            this.actividades[j].week=res[0].week
            
          });
       
  
     
  }
  list_act(){

    var postdata={id:this._proyecto}
    //console.log(postdata);
    this.Ver_rpt(this._tipo,postdata);
  }
  chn_se_asesor($event){
    //console.log($event);
    var id_proyecto_={
        id:this.hididproyecto,
        id_asesor:$event
    };     
    //console.log($event);
    if($event=='T'){
      this.tareas_(id_proyecto_);
    }else{
      this.tareas_asesor(id_proyecto_);
    }
  }
  facturas:any;
  tareas_asesor(itm:any){
    this.proyevto_nombre=itm.proyectos;
    //console.log("tareas");
    //console.log(itm);
    //localStorage.setItem("actividad_nombre",itm.proyectos)
    this.actividad_nombre=localStorage.getItem("actividad_nombre");
    this.v_proyectos=4;
    //localStorage.setItem("id_proyecto",itm.id);
    this.hididproyecto=itm.id;
    var _usuario_filter="N";
    if(Number(this.facturas)==1){
      _usuario_filter="S";
    }
    let postData={
      id_proyecto:itm.id,
      id_asesor:itm.id_asesor,
      usuario_filter:_usuario_filter,
      id_usuario:this.usuario,
    };
    this.loading=true;
    this.total_horas=0;
    this.authService.service("/api/get_actividades_asesor",postData)
    .then(
        data => {
          this.loading=false;
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat); 
          for(let i=0;i<data.length;i++){
            //if (data[i].Tipo=='H')
            this.total_horas=this.total_horas+data[i].horas;           
          } 
          //console.log(data);  
          this.actividades=data;
        },
        error => {
            this.loading=false;
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta..! tareas_', '', 'error');
        }); 

  }
  actividades_aux={
    id:0,
    fecha_:"",
    hora_:"",
    horas:0,
    horas_por_semana:0,
    min:0,
    max:0,
    interviene:"",
    avance:"",
    actividad:"",
    week:0
  };
  calcula_horas_aux(){
    console.log(this.actividades)
    this.actividades.sort((a,b) => {
      if (a.fecha > b.fecha ) {return 1;
      }else if (a.fecha < b.fecha ) {return -1;
      }else return 0;});
   
    //console.log("calcula horas")
    var week_aux=0;
    this.total_horas=0; 
    var totalhoras_semana=0;
    for(var i=0;i<this.actividades.length;i++){
      this.total_horas=this.total_horas+this.actividades[i].horas;     
      this.actividades[i].totalhoras=0;
      if(week_aux==0){
        totalhoras_semana=this.actividades[i].horas+totalhoras_semana;
      }else if(week_aux!=this.actividades[i].week  ){
        //console.log("week:"+week_aux+" totalhoras_semana:"+totalhoras_semana)
        try {
          this.actividades[i-1].totalhoras=totalhoras_semana;        
        } catch (error) {
          
        }

        totalhoras_semana=this.actividades[i].horas;
      }else{
        totalhoras_semana=this.actividades[i].horas+totalhoras_semana;
      }
      week_aux=this.actividades[i].week;
      if(i==(this.actividades.length-1)){
        this.actividades[i].totalhoras=totalhoras_semana;   
      }
    }
  }
  tareas_(itm:any){
    this.proyevto_nombre=itm.proyectos;
    this.hid_sel="";        
    this.actividad_nombre=localStorage.getItem("actividad_nombre");
    this.v_proyectos=4;
    this.hididproyecto=itm.id;
    var _usuario_filter="N";
    if(Number(this.facturas)==1){
      _usuario_filter="S";
    }
    let postData={
      id_proyecto:itm.id,      
      usuario_filter:_usuario_filter,
      id_usuario:this.usuario,
      sufijo:localStorage.getItem("sufijo")
    };
    this.loading=true;
    this.total_horas=0;
    this.authService.service("/api/get_actividades",postData)
    .then(
        data => {
          this.loading=false;
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);
          this.actividades=data;
          
          
          this.calcula_horas_aux();         
        },
        error => {
            this.loading=false;
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta..! tareas_', '', 'error');
        }); 

  }
  proyecto={
    clave:"",
    noorden:"",
    nombre:"",
    tipo:"",
    chora:0,
    hora:0,
    moneda:"",
    ajuste:0,
    responsable:0
  }
  can_actpry(){
    this.v_proyectos=2;
  }
  eliminae_pry(itm:any){
    if(confirm("Desea Eliminar el proyecto?")==false)return; 
    this.hididproyecto=itm.id;
    let postData={
      id_pry:itm.id,
    }
    this.loading=true;
    this.authService.service("/api/del_proyecto",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat); 
          this.ls_proyectos();
          this.v_proyectos=2;
          swal.fire('¡Ok! ', '', 'success');
          this.loading=false;
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta..! upd_pry', '', 'error');
            this.loading=false;
        }); 
    
  }
  bndeditpry:boolean=false;
  id_o:Number=0;
  id_f:Number=0;
  dup_act_o_pry(){
    this.v_proyectos=5;
  }
  can_dupl(){
    
    this.v_proyectos=2;
  }
  dupl_act_pry(){
    //console.log(this.id_o)
    //console.log(this.id_f)
    if(this.id_o==this.id_f)return;
    let postData={
      id_o:this.id_o,
      id_f:this.id_f
    }
    //console.log(postData);
    this.authService.service("/api/sp_dupactlpry",postData)
    .then(
        data => {
          this.loading=false;
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat); 
          this.ls_proyectos();
          this.v_proyectos=2;
          swal.fire('¡Ok! ', '', 'success');
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            this.loading=false;
            swal.fire('¡API incorrecta..! cmb_pry', '', 'error');
        }); 
  }
  dupl_pry(itm){
    if(confirm("Desea duplicar este proyecto?")==false)return false;
    let postData={
      id:itm.id
    }
    //console.log(postData);
    this.authService.service("/api/dupl_proyecto",postData)
    .then(
        data => {
          this.loading=false;
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat); 
          this.ls_proyectos();
          this.v_proyectos=2;
          swal.fire('¡Ok! ', '', 'success');
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            this.loading=false;
            swal.fire('¡API incorrecta..! cmb_pry', '', 'error');
        }); 
  }
  editar_pry(itm:any){
    //console.log(itm);
    this.hididproyecto=itm.id;
    this.proyecto.nombre=itm.proyectos;
    this.proyecto.tipo=itm.Tipo;
    this.proyecto.chora=itm.costo_hora;
    this.proyecto.responsable=itm.id_responsable_cliente;
    this.proyecto.moneda=itm.moneda;
    this.proyecto.ajuste=itm.Ajuste;  
    this.proyecto.noorden=itm.noorden;
    this.proyecto.hora=itm.hora_pry;
    this.proyecto.clave=itm.factura;
    this.bndeditpry=false;
    this.v_proyectos=1;
  }
  hididproyecto:any;

  cmb_pry(){
    if(confirm("Desea cambiar de proyecto esta actividad?")==false)return false;
    let postData={
      id_actividad:this.actividad.id,
      id_proyecto:this.actividad.id_proyecto
    }
    this.loading=true;
    //console.log(postData);
    this.authService.service("/api/upd_actividad_proyecto",postData)
    .then(
        data => {
          this.loading=false;
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat); 
          this._secc(4); 
          swal.fire('¡Ok! ', '', 'success');
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            this.loading=false;
            swal.fire('¡API incorrecta..! cmb_pry', '', 'error');
        }); 

  }
  responsable=[];
  get_responsable(){
    let postData={
      id:this.cliente
    };
    //console.log(postData);
    this.authService.service("/api/get_responsable_cliente",postData)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        this.responsable=res;
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('¡API incorrecta! ', '', 'error');
      });   
  }
  upd_pry(){
    if(this.valida_pry()==false)return;
    let postData={
      proyecto:this.proyecto.nombre,
      id_usuario:this.usuario,
      id_cliente:this.cliente,
      tipo:this.proyecto.tipo,
      chora:this.proyecto.chora,
      horas:Number(this.proyecto.hora),
      moneda:this.proyecto.moneda,
      ajuste:this.proyecto.ajuste,
      id_proyecto:this.hididproyecto,
      noorden:this.proyecto.noorden,
      clave:this.proyecto.clave,
      responsable:this.proyecto.responsable
    };
    this.loading=true;
   //console.log(postData);
    this.authService.service("/api/upd_proyecto",postData)
    .then(
        data => {
          this.loading=false;
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat); 
          this.ls_proyectos();
          this.v_proyectos=2;
          swal.fire('¡Ok! ', '', 'success');
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            this.loading=false;
            swal.fire('¡API incorrecta..! upd_pry', '', 'error');
        }); 
    
  }
  valida_pry(){
    if(this.proyecto.nombre=="" || this.proyecto.nombre==null || this.proyecto.nombre==undefined){
      swal.fire('¡Completar nombre de proyecto! ', '', 'warning');
      return false;
    }
    if(this.proyecto.tipo=="" || this.proyecto.tipo==null || this.proyecto.tipo==undefined){
      swal.fire('¡Completar tipo de proyecto! ', '', 'warning');
      return false; 
    }
    return true;
  }
  gda_pry(){
    if(this.valida_pry()==false)return;
    let postData={
      proyecto:this.proyecto.nombre,
      id_usuario:this.usuario,
      id_cliente:this.cliente,
      tipo:this.proyecto.tipo,
      horas:Number(this.proyecto.hora),
      chora:this.proyecto.chora,
      moneda:this.proyecto.moneda,
      ajuste:this.proyecto.ajuste,
      noorden:this.proyecto.noorden,
      clave:this.proyecto.clave,
      responsable:this.proyecto.responsable
    };
    //console.log(postData);
    this.authService.service("/api/gda_proyecto",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat); 
          this.ls_proyectos();
          this.v_proyectos=2;
          swal.fire('¡Ok! ', '', 'success');
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta..! gda_pry', '', 'error');
        }); 
    
  }
  ls_programado(){
    let postData={
      id_cliente:this.cliente,
    };
    this.loading=true;
    //console.log(postData);
    this.authService.service("/api/get_seguimiento_programado",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat); 
          //console.log(data);  
            this._programado=data;
            this.loading=false;
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta..! ls_programado', '', 'error');
            this.loading=false;
        }); 
      
  }
  ls_seguimiento(){  
    
    this.loading=true;                 
    let postData={
      id_cliente:this.cliente,
    };
    //console.log(postData);
    this.authService.service("/api/get_seguimiento",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat); 
         //console.log(data);  
            this._seguimiento=data;
            this.loading=false;
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta..! ls_seguimiento', '', 'error');
            this.loading=false;
        }); 
      
  }
  orden:any;
  ls_orden(){
    let postData={
      id_cliente:this.cliente     
    };
    //console.log(postData);  
    this.authService.service("/api/get_noorden",postData)
    .then(
        data => {
          
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);
          this.orden=res;
          //console.log(res);
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta..! gda_seguimiento', '', 'error');
        }); 
      
  }
  _proyecto:any;
  _tipo:any;
  gen_rpt_(){
    this.btn_pdf=true;
  }
  _rpt(itm){
    this.bnd_fct=true;
    this.loading=true;
    //console.log(itm);
    this._proyecto=itm.id;
    this._tipo=itm.Tipo;
    this.Ver_rpt(this._tipo,itm);
    this.loading=false;
  }
  gda_seguimiento(){
    //console.log(this.usuario);return;
    var _seguimiento;
    var _hora;
    if(Number(this.seguimiento.programado)==1){
      _seguimiento="S"
      _hora=this.seguimiento.fecha.year.toString()+"/"+
            this.seguimiento.fecha.month.toString()+"/"+
            this.seguimiento.fecha.day.toString()+" "+
            this.seguimiento.hora.hour.toString()+":"+
            this.seguimiento.hora.minute.toString();
    }else{
      _seguimiento="N"
      _hora=null;
    }

    
    if(this.valida_seguimiento()==true){                     
    let postData={
      tipo:this.seguimiento.tipo,
      descripcion:this.seguimiento.descripcion,
      nuevo_seguimiento:_seguimiento,
      tipo_seguimiento:this.seguimiento.tipo,
      fecha_nseguimiento:_hora,
      notas:this.seguimiento.notas,
      id_cliente:this.cliente,
      id_usuario:this.usuario,
      noorden:this.seguimiento.noorden
    };
    //console.log(postData);  
    this.authService.service("/api/gda_seguimiento",postData)
    .then(
        data => {
            swal.fire('¡Ok! ', '', 'success');
            this.ls_seguimiento();
            this.tab=2;
            if(Number(this.seguimiento.programado)==1){
              var tipo_="";
              /*
              for(let i=0;i<this.tipo_seguimiento.length;i++){
                if(this.tipo_seguimiento[i].id==this.seguimiento.tipo) {
                  tipo_=this.tipo_seguimiento[i].tipo;
                }  
              }

              let postdata2={
                id:0,
                "fecha_": this.seguimiento.fecha.year.toString()+"/"+
                          this.seguimiento.fecha.month.toString()+"/"+
                          this.seguimiento.fecha.day.toString(),
                "hora_":  this.seguimiento.hora.hour.toString()+":"+
                          this.seguimiento.hora.minute.toString(),
                "summary":"Seguimiento: ("+ tipo_ +") "+this.preventa.rs,
                "description": this.seguimiento.descripcion +", "+this.seguimiento.notas
                
              }
              //console.log(postdata2);
              this.authService.service("/api/google_calendar",postdata2).then(
                data=>{
                  console.log(data);
                }
              );
              */
            }
  


        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta..! gda_seguimiento', '', 'error');
        }); 
      }
  }
  can_seguimiento(){
    this.tab=2;
  }
  nvo_seguimiento(){
  
    this.tab=2.1;
    this.seguimiento.noorden="";
    this.seguimiento.descripcion="";
    this.seguimiento.notas="";
    this.seguimiento.tipo=0;
    this.seguimiento.fecha.year=2021;
    this.seguimiento.fecha.month=0;
    this.seguimiento.fecha.day=0;
    this.seguimiento.hora.minute=0;
    this.seguimiento.hora.hour=0;

  }

  recordatorio:any;
  seguimiento={    
    id:0,
    noorden:"",
    fecha : {year: 0, month: 0, day: 0},
    hora : {hour: 0, minute: 0},
    tipo:0,
    descripcion:"",
    programado:"",
    notas:""
  }
  preventa={
    id:0,
    nombre:"",
    paterno:"",
    materno:"",
    rs:"",
    rfc:"",
    correo:"",
    tel1:"",
    tel2:"",
    ext1:"",
    ext2:"",
    pais:"",
    estado:"",
    municipio:"",
    colonia:"",
    calle:"",
    cp:"",
    medio:""
  
  }
  rpt_act:any;
  reporte={
    cliente:"cliente",
    contacto:"contacto",
    cargo:"cargo",
    semana:"semana",
    fecha:"fecha"
  }
  v_tpopry:boolean=false;
  fn_hp(t){
    this.rpt_act=[];
    this.total_horas=0;
    this.total_avance=0;
    //console.log(this.proyectos);
    switch (t) {
      case 'h':
        this.v_tpopry=true;
        break;
      case 'p':
        this.ls_proyectos();
        this.v_tpopry=false;
          break;      
      default:
        break;
    }
  }
  msg;
  total_horas:any=0;
  total_avance:any=0;
  hidid_:any;
  addEvent($event){
    //console.log("addevent");
    //console.log($event);
    //console.log("addevent");
  }
  ver_rpt_1($event){
    this.rpt_act=[];
    this.actividad.fechaIni.year=$event.year;
    this.actividad.fechaIni.month=$event.month;
    this.actividad.fechaIni.day=$event.day;
    //console.log($event);
    var postdata={id:this._proyecto}
    this.Ver_rpt(this._tipo,postdata);
  }
  ver_rpt_2($event){
    this.rpt_act=[];
    this.actividad.fechaFin.year=$event.year;
    this.actividad.fechaFin.month=$event.month;
    this.actividad.fechaFin.day=$event.day;
    //console.log($event);
    var postdata={id:this._proyecto}
    this.Ver_rpt(this._tipo,postdata);
  }
  
  btn_pdf:boolean=false
  bnd_fct:boolean=false

  msg_horas:any;
  Ver_rpt(t,itm){ 
    this.loading=true;
    this.msg_horas="" 
    this.hidid_=itm.id;
    this.total_horas=0;
    this.total_avance=0;
    this.rpt_act=[];
    var f1=this.actividad.fechaIni.year+'-'+this.actividad.fechaIni.month+'-'+this.actividad.fechaIni.day;
    var f2=this.actividad.fechaFin.year+'-'+this.actividad.fechaFin.month+'-'+this.actividad.fechaFin.day
    let postData={
      cliente_id:this.cliente,      
      f1:f1,
      f2:f2,
      proyecto_id:itm.id,
      id_proyecto:itm.id
    };
    //console.log(postData);
    switch (t) {      
      case 'H':
      this.btn_pdf=true; 
      this.v_tpopry=true;     
        this.msg="";
        this.authService.service("/api/get_actividades_rpt_pry",postData)
        .then(
            data => {
              var dat = JSON.stringify(data);
              var res = JSON.parse(dat);              
              //console.log(data);
              this.rpt_act=data;
              for(let i=0;i<data.length;i++){
                //if (data[i].Tipo=='H')
                this.total_horas=this.total_horas+data[i].horas;
               
              } 
              var hora_pry
              try {
                 hora_pry=data[0].hora_pry;  
              } catch (error) {
                 hora_pry=0;
              }
              
              //console.log("horas");
              //console.log(itm.hora_pry);
              //console.log(this.total_horas);
              if(hora_pry<this.total_horas){
                this.btn_pdf=false;
                if(hora_pry==0){
                  this.msg_horas="El Proyecto no tiene definido el maximo numero de horas>0.";
                }else{
                  this.msg_horas="El maximo de horas permitido es "+hora_pry + ", total="+ this.total_horas +", exedente ("+(Number(this.total_horas)-Number(hora_pry))+")";
                }
              }               
              if(data.length==0){
                this.msg="Sin datos";
              }
            },
            error => {            
              console.log('¡API incorrecta! Ver_rpt');
              this.loading=false;
            });  
        break; 
        case 'P':
          this.msg="";
          this.v_tpopry=false;
          this.btn_pdf=true; 
          this.authService.service("/api/get_actividades_rpt_pry",postData)
          .then(
              data => {
                var dat = JSON.stringify(data);
                var res = JSON.parse(dat);              
                //console.log(data);
                this.rpt_act=data;
                for(let i=0;i<data.length;i++){
                  //if (data[i].Tipo=='P')                  
                  this.total_avance=this.total_avance+data[i].avance;
                }    
                if(this.total_avance>0){
                  this.total_avance=this.total_avance/(data.length);          
                }
                this.total_avance=Math.round(this.total_avance);
                if(data.length==0){
                  this.msg="Sin datos";
                }
              },
              error => {            
                console.log('¡API incorrecta! Ver_rpt');
                this.loading=false;
              });  
        break;
        default:
        break;
      }
      this.loading=false;
  }
 


  url:any="/pdf";
  _imprimir(){   
    //console.log(itm);
    //console.log(t);
    localStorage.setItem("t",this._tipo);
    localStorage.setItem("cliente_",this.cliente);
    localStorage.setItem("cliente_id",this.cliente);
    var f1=this.actividad.fechaIni.year+'-'+this.actividad.fechaIni.month+'-'+this.actividad.fechaIni.day;
    var f2=this.actividad.fechaFin.year+'-'+this.actividad.fechaFin.month+'-'+this.actividad.fechaFin.day        
    localStorage.setItem("f1",f1);
    localStorage.setItem("f2",f2);
    localStorage.setItem("proyecto_id",this._proyecto);  
    this.router.navigate([]).then(result => {  window.open('#/pdf', '_blank'); });
  }
}
